<!-- <div style="height: 100px;width:100px;z-index:+1; background-color: aqua;">he</div> -->
<div class="innerBanner" style="background-image: url('{{ bannerImage }}')" (click)="imageClick(0)">
  <!-- inner banner-->
  <div class="bannerText">
    <h1>{{ islandsBannerAndContent.bannerTitle }}</h1>
  </div>
</div>

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
</p-galleria>

<!-- <app-breadcrumb></app-breadcrumb> -->
<app-breadcrumb-row></app-breadcrumb-row>
<div class="container">
  <div class="contentPanel">
    <p [innerHTML]="islandsBannerAndContent.content"></p>
    <p>&nbsp;</p>
  </div>

  <div class="highlightSection" *ngIf="islandType == 'outerIslands'">
    <h1 class="text-center">{{ 'Island Groups' | translate }}</h1>
    <div class="popular-items">
      <p-carousel
        [value]="outerIslandGroups"
        styleClass="custom-carousel"
        [numVisible]="4"
        [numScroll]="1"
        [circular]="true"
        [responsiveOptions]="responsiveOptions"
        class="islands-carousel"
        [ngClass]="this.language"
      >
        <ng-template let-product pTemplate="item">
          <div class="product-item slider-arrow">
            <a href="javascript:void(0)" (click)="islandGroups(product)">
              <div class="product-item-content">
                <div class="image">
                  <img
                    [src]="product.uri ? product.uri : '../../../assets/images/NoImage.jpg'"
                    [alt]="product.name"
                    class="product-image slider-image"
                  />
                </div>
                <div class="title">
                  <h3>{{ product.name }}</h3>
                </div>
              </div>
            </a>
          </div>
        </ng-template>
      </p-carousel>
    </div>
    <div class="viewall-btn">
      <a (click)="islandsAllGroups(islandType, 'outerIslandGroups')"
        >{{ 'View All' | translate }}<i class="pi pi-angle-right"></i
      ></a>
    </div>
  </div>
  <div class="highlightSection">
    <h1 translate class="text-center">Islands with Accommodation</h1>
    <div class="popular-items">
      <p-carousel
        [value]="islandsWithAccom"
        styleClass="custom-carousel"
        [numVisible]="4"
        [numScroll]="1"
        [circular]="true"
        [responsiveOptions]="responsiveOptions"
        class="islands-carousel"
        [ngClass]="this.language"
      >
        <ng-template let-product pTemplate="item">
          <div class="product-item slider-arrow">
            <a href="javascript:void(0)" (click)="islands(product.view_node)">
              <div class="product-item-content">
                <div class="image">
                  <img
                    [src]="product.uri ? product.uri : '../../../assets/images/NoImage.jpg'"
                    [alt]="product.name"
                    class="product-image slider-image"
                  />
                </div>
                <div class="title">
                  <h3>{{ product.title }}</h3>
                </div>
              </div>
            </a>
          </div>
        </ng-template>
      </p-carousel>
    </div>
    <div class="viewall-btn">
      <a (click)="islandsAll(islandType, 'islandsWithAccom')"
        >{{ 'View All' | translate }}<i class="pi pi-angle-right"></i
      ></a>
    </div>
  </div>
  <div class="highlightSection">
    <!-- highlights-->
    <h1 translate class="text-center">Islands without Accommodation</h1>
    <div class="popular-items">
      <p-carousel
        [value]="islandsWithoutAccom"
        styleClass="custom-carousel"
        [numVisible]="4"
        [numScroll]="1"
        [circular]="true"
        [responsiveOptions]="responsiveOptions"
        class="islands-carousel"
        [ngClass]="this.language"
      >
        <ng-template let-product pTemplate="item">
          <a href="javascript:void(0)" (click)="islands(product.view_node)">
            <div class="product-item slider-arrow">
              <div class="product-item-content">
                <div class="image">
                  <img
                    [src]="product.uri ? product.uri : '../../../assets/images/NoImage.jpg'"
                    [alt]="product.name"
                    class="product-image slider-image"
                  />
                </div>
                <div class="title">
                  <h3>{{ product.title }}</h3>
                </div>
              </div>
            </div>
          </a>
        </ng-template>
      </p-carousel>
    </div>
    <div class="viewall-btn">
      <a (click)="islandsAll(islandType, 'islandsWithoutAccom')"
        >{{ 'View All' | translate }}<i class="pi pi-angle-right"></i
      ></a>
    </div>
  </div>
</div>
